"use client";
import { jsx as l } from "react/jsx-runtime";
import { memo as c } from "react";
import e from "../components/Icon/SvgIcon.js";
const o = (a) => /* @__PURE__ */ l(
  e,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.479 20.015c.289 0 .581.074.862.26l.667.445.666-.443a2.5 2.5 0 0 1 2.729.002l.664.44.665-.442a2.46 2.46 0 0 1 2.727-.001l.668.444.667-.444c.705-.468 1.483-.222 2.091.104V3.619c-.609.329-1.384.575-2.091.106l-.668-.445-.665.443c-.829.554-1.9.552-2.728-.001l-.667-.443-.665.443a2.45 2.45 0 0 1-2.727.002l-.667-.445-.663.444c-.703.47-1.485.224-2.094-.105V20.38c.366-.196.793-.365 1.229-.365m5.588 1.984c-.213 0-.427-.061-.615-.186l-.744-.495a1.22 1.22 0 0 0-1.339-.002l-.747.498a1.11 1.11 0 0 1-1.228-.001l-.747-.496c-.296-.197-1.002.27-1.339.497a.76.76 0 0 1-.788.03 1.02 1.02 0 0 1-.52-.868V2.882a.838.838 0 0 1 1.311-.696c.336.226 1.038.696 1.337.498l.744-.498a1.11 1.11 0 0 1 1.226-.003l.749.5c.408.27.934.27 1.34 0l.746-.497c.37-.246.852-.25 1.226-.001l.748.497c.406.273.932.272 1.341 0l.745-.496a1.11 1.11 0 0 1 1.228 0l.746.498c.297.196 1.001-.271 1.339-.498a.85.85 0 0 1 .866-.043c.273.146.443.43.443.739v18.094c0 .348-.214.705-.52.869a.76.76 0 0 1-.788-.031l-.004-.003c-.338-.227-1.037-.695-1.336-.494l-.746.497a1.11 1.11 0 0 1-1.228-.001l-.746-.496a1.2 1.2 0 0 0-1.341 0l-.745.497c-.187.124-.4.185-.614.185m3.7-13.941h-7.4a.625.625 0 0 1 0-1.25h7.4a.625.625 0 0 1 0 1.25m-7.4 6.089h7.4a.625.625 0 0 0 0-1.25h-7.4a.625.625 0 0 0 0 1.25m7.4 3.044h-4.192a.625.625 0 0 1 0-1.25h4.193a.625.625 0 0 1 0 1.25m-7.4-6.09h7.4a.625.625 0 0 0 0-1.25h-7.4a.625.625 0 0 0 0 1.25",
        clipRule: "evenodd"
      }
    )
  }
), r = c(o);
export {
  r as WarehouseReceipts,
  r as default
};
